import { render, staticRenderFns } from "./ACustomerList.vue?vue&type=template&id=19be6f93&scoped=true"
import script from "./ACustomerList.vue?vue&type=script&lang=js"
export * from "./ACustomerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19be6f93",
  null
  
)

export default component.exports